import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Col, Image, Row } from 'react-bootstrap'
import { visionBgImage } from '../../assets'

export default function ApproachSection() {
  return (
    <Row className='mx-0 approach-section'>
      <Col md={6} className='d-none d-md-flex'>
        <Image src={visionBgImage} />
      </Col>
      <Col md={6} className='approach-description d-flex flex-column justify-content-center'>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <h5 style={{ textAlign: 'start', fontWeight: '800', }}>OUR APPROACH</h5>
        </AnimationOnScroll>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <h2 style={{ textAlign: 'start', fontWeight: '800' }} className='mb-4'>Committed to being Eco-responsible</h2>
        </AnimationOnScroll>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <p align='left' style={{ fontWeight: '500', fontSize: '1.1em' }}>Kaptain plywood sources wood from tropical plantations, and essentially all of the wood entering
            our factory is utilized within our manufacturing process,
            which helps in minimum wastage of product and minimize the harm to our sensitive ecosystem.</p>
        </AnimationOnScroll>
      </Col>
    </Row>
  )
}
